export const SET_SNACKBAR = 'SET_SNACKBAR';
export const SET_GLOBAL_SOURCE = 'SET_GLOBAL_SOURCE';
export const SET_BULK_SUBMISSION_TEMPLATE_DETAILS =
  'SET_BULK_SUBMISSION_TEMPLATE_DETAILS';
export const SET_BATCH_ID = 'SET_BATCH_ID';
export const SET_VALIDATING_ENTITY_ACCESS = 'SET_VALIDATING_ENTITY_ACCESS';
